document.addEventListener('DOMContentLoaded', function() {
    $('.chat-title').click(function() {
        $('#chat').addClass('active');
    });

    $('.ch-close').click(function(event) {
        event.stopPropagation();
        $('#chat').removeClass('active');
    });

    $('.next-step').click(function() {
        var _this = this;
        var message = $('[name=chat_text]').val();
        next_step(message, _this);
    });

    $('[name=chat_text]').on('keypress', function(event) {
        if (event.key === 'Enter') {
            var message = $('[name=chat_text]').val();
            next_step(message, $(this).next());
        }
    });

    function next_step(message, _this){
        if (message && message.length > 3) {
            $('.dialog').append('<div class="item user"><div class="answer_user"><p>'+message+'</p></div></div>');
            setTimeout(function (){
                $('.dialog').append('<div class="item">' +
                    '<img src="'+$(_this).data('img')+'"> ' +
                    '<div class="answer">' +
                    '<p>'+$(_this).data('answer')+'</p>' +
                    '</div>' +
                    '</div>');

                $(_this).parents('.chat-input').addClass('display-none');
                $('.chat-phone').removeClass('display-none');
            }, 500);
        }else{
            $('[name=chat_text]').addClass('error-phone');
        }
    }

    $('.send_phone').click(function() {
        var _this = this;
        var phone = $('[name=chat_phone]').val();
        var comment = $('.answer_user p').text();

        send_phone(phone, comment, _this);
    });

    $('[name=chat_phone]').on('keypress', function(event) {
        if (event.key === 'Enter') {
            var phone = $('[name=chat_phone]').val();
            var comment = $('.answer_user p').text();

            send_phone(phone, comment, $(this).next());
        }
    });

    function send_phone(phone, comment, _this){
        if (phone && phone.length > 11) {
            var object = {
                _token: $('meta[name="csrf-token"]').attr('content'),
                comment: comment,
                phone: phone,
                locale: $('html').attr('lang'),
            };

            $.ajax({
                type: 'POST',
                url: '/chat_save',
                data: object,
                success: function(data){
                    if(data.success){
                        $('.dialog').append('<div class="item">' +
                            '<img src="'+$(_this).data('img')+'"> ' +
                            '<div class="answer">' +
                            '<p>'+$(_this).data('answer')+'</p>' +
                            '</div>' +
                            '</div>');

                        $('.chat-phone').addClass('display-none');
                        $('.chat-container').animate({
                            scrollTop: $('.chat-container')[0].scrollHeight
                        }, 'slow');
                    } else {
                        alert(data.message);
                    }
                }
            });
        }else{
            $('[name=chat_phone]').addClass('error-phone');
        }
    }

    $('input[name=chat_phone]').on("change paste keyup click", function () {
        $(this).mask('+37100000000');
    });
});
